import { render } from "./Checkbox.vue?vue&type=template&id=6c56bc3d&scoped=true&ts=true"
import script from "./Checkbox.ts?vue&type=script&lang=ts&external"
export * from "./Checkbox.ts?vue&type=script&lang=ts&external"

import "./Checkbox.scss?vue&type=style&index=0&id=6c56bc3d&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c56bc3d"]])

export default __exports__